import { NgModule } from '@angular/core';
import {ROUTING_MODULE_IMPORTS, ROUTING_MODULE_EXPORTS, ROUTING_MODULE_PROVIDERS} from './routingDependencies';

@NgModule({
  imports: ROUTING_MODULE_IMPORTS,
  exports: ROUTING_MODULE_EXPORTS,
  providers: ROUTING_MODULE_PROVIDERS
})
export class EnrollmentRoutingModule { }
